<template>
  <section class="app-main">
          <!-- <router-view :key="key"></router-view> -->
      <router-view></router-view>
  </section>
</template>

<script>
export default {
  name: 'LayoutCenter',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layouts/LayoutCenter.vue